// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__3PHJS","sk-scaleout":"spinner_sk-scaleout__2ksMA"};